// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleTitle_root__Nb9Xh","featureOrTwoCol":"ArticleTitle_featureOrTwoCol__4sJHf","twoCol":"ArticleTitle_twoCol__KOGWs"};